import type { ReloadState } from '@/analytics/types'

const RELOAD_FLAG_KEY = 'chunk-error-reload'

function hasReloadedInThisSession(): boolean {
  try {
    return Boolean(sessionStorage.getItem(RELOAD_FLAG_KEY))
  } catch {
    return false
  }
}

function markReload(): void {
  try {
    const state: ReloadState = { timestamp: Date.now() }
    sessionStorage.setItem(RELOAD_FLAG_KEY, JSON.stringify(state))
  } catch {
    // sessionStorage unavailable (private browsing edge cases)
  }
}

export function clearReloadFlag(): void {
  try {
    sessionStorage.removeItem(RELOAD_FLAG_KEY)
  } catch {
    // noop
  }
}

function forceReload(): void {
  if (hasReloadedInThisSession()) return
  markReload()
  window.location.reload()
}

function isChunkLoadError(error: unknown): boolean {
  if (error instanceof Error) {
    return (
      error.name === 'ChunkLoadError' ||
      error.message.includes('Failed to fetch dynamically imported module') ||
      error.message.includes('Importing a module script failed') ||
      error.message.includes('error loading dynamically imported module')
    )
  }
  return false
}

export function registerChunkErrorHandler(): void {
  window.addEventListener('vite:preloadError', () => {
    forceReload()
  })

  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    if (isChunkLoadError(event.reason)) {
      event.preventDefault()
      forceReload()
    }
  })
}
